export default "__VITE_ASSET__Cf75HnuB__"